import {
  GLOBAL_POLICY_CONTROL_SPEC,
  TAG_MANAGER_CONSENT_POLICY_BY_GEO_CONFIG,
} from '../constants'

export function enabledExperiment(specName: string) {
  if (typeof (window as any)?.wixTagManager?.getConfig !== 'function') {
    return false
  }
  return (
    (window as any)?.wixTagManager?.getConfig()?.experiments?.[specName] ===
    'true'
  )
}

// CIPA banner is the US flow. Show it only when the petri experiment says US
// AND the geo dynamic config does NOT indicate EU or US-CA (those have their
// own flow and must not see CIPA).
export function shouldUseCipaBanner(): boolean {
  if (typeof (window as any)?.wixTagManager?.getConfig !== 'function') {
    return false
  }
  const config = (window as any).wixTagManager.getConfig()

  // geo by old petri experiment currently indicates US   
  const cipaUsExperimentEnabled =
    config?.experiments?.[GLOBAL_POLICY_CONTROL_SPEC] === 'true'
  // geo by dynamic config currently indicates EU or US-CA     
  const gdprGeoConfigEnabled =
    !!config?.dynamicConfigs?.[TAG_MANAGER_CONSENT_POLICY_BY_GEO_CONFIG]
  // means user is in the US and not in EU or US-CA  
  return cipaUsExperimentEnabled && !gdprGeoConfigEnabled
}
